import { type ReactElement } from 'react';
import { Link } from 'react-router';
import { type Recipe } from '../types';
import { timeAgo } from '../lib/format';
import { recipePath } from '../lib/paths';

interface FeaturedRecipeCardProps {
	recipe: Recipe;
}

/** A recently updated recipe: one ruled row, the name and when it changed. */
function FeaturedRecipeCard({ recipe }: FeaturedRecipeCardProps): ReactElement {
	const { name, description, updated_at } = recipe;

	return (
		<Link className='res' to={recipePath(recipe)} state={{ selectedRecipe: recipe }}>
			<span>
				<span className='res__name title'>{name}</span>
				<span className='res__desc caption'>{description}</span>
			</span>
			<span className='caption muted' style={{ whiteSpace: 'nowrap' }}>Updated {timeAgo(new Date(updated_at))}</span>
		</Link>
	);
}

export default FeaturedRecipeCard;
